const __LOADING_AUTO_CLOSE_DELAY__ = 60 * 1000;// 自动关闭loading效果的延迟

const useLoadingEl = () => {
	let el = document.querySelector(".csr-loading");
	if (el) {return el;}
	el = document.createElement("div");
	el.className = "csr-loading";
	el.innerHTML = "<i class='iconfont-midea iconloading'></i>";
	document.body.appendChild(el);
	return el;
}

export const useFormV3Loading = () => {
	let loadingEl = "";
	let timer = null;
	const showLoading = () => {
		loadingEl = useLoadingEl();
		// 这里设置定时器是为了当代码发生了错误，导致loading效果没有关闭时，设置定时让其关闭
		timer = setTimeout(() => {
			hideLoading();
			clearTimeout(timer);
			timer = null;
		},__LOADING_AUTO_CLOSE_DELAY__);
	}
	
	const hideLoading = () => {
		loadingEl && document.body.removeChild(loadingEl);
	}
	return {
		showLoading,
		hideLoading
	}
}
